import type { ReactNode } from "react";

import type { ConnectionStatus } from "@client/realtime/game-socket";

export function ConnectionStatusBanner({
  status,
  waitingFor,
}: {
  status: ConnectionStatus;
  waitingFor?: string | undefined;
}): ReactNode {
  if (status === "online" && !waitingFor) return null;
  return (
    <aside className="connection-status" role="status" aria-live="polite">
      {status === "offline"
        ? "Offline — your confirmed progress is safe. Reconnecting…"
        : status === "connecting"
          ? "Connecting to the room…"
          : status === "expired"
            ? "This room has expired."
            : status === "invalid"
              ? "Your saved seat is no longer valid."
              : `Waiting for ${waitingFor} to reconnect. Their turn will not be skipped.`}
    </aside>
  );
}
